import React, { Component, PropTypes } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import classNames from 'classnames';
import Image from 'components/Image';

class Footer extends Component {
  static propTypes = {
    footerAdhesionOffset: PropTypes.bool,
    backgroundColor: PropTypes.string,
    backgroundUri: PropTypes.string,
    textColor: PropTypes.string,
    linkColor: PropTypes.string,
    privacyStatementUri: PropTypes.string,
    termsOfServiceUri: PropTypes.string,
    footerLinks: PropTypes.array
  }

  static contextTypes = {
    config: PropTypes.object.isRequired
  }

  static defaultProps = {
    footerAdhesionOffset: false,
    backgroundColor: '#FFF',
    textColor: '#000',
    linkColor: '#FFF',
    footerLinks: []
  }

  render() {
    const {
      config: {
        affiliate: {
          displayName: affiliateDisplayName = ''
        } = {}
      }
    } = this.context;

    const {
      footerAdhesionOffset,
      backgroundColor,
      textColor,
      linkColor,
      privacyStatementUri,
      termsOfServiceUri,
      footerLinks
    } = this.props;

    const linkStyle = { color: linkColor };

    const privacyPolicy = <a href={privacyStatementUri} target="_blank" style={linkStyle} rel="noopener noreferrer"> Privacy Policy</a>;
    const termsOfService = <a href={termsOfServiceUri} target="_blank" style={linkStyle} rel="noopener noreferrer"> Terms of Service</a>;
    const adChoices = <a href="http://www.aboutads.info/choices" target="_blank" style={linkStyle} rel="noopener noreferrer"> Ad Choices</a>;

    const className = classNames('Footer',
      { 'adhesion': footerAdhesionOffset }
    );

    return (
      <div className={className} style={{backgroundColor, color: textColor}}>
        <Grid>
          <Row>
            <Col xs={12}>
              <div className="Footer-copyrightText">
                All content &copy; copyright { affiliateDisplayName }.
              </div>
              
              { footerLinks.length &&
                <div className="Footer-footerLinks">
                  { footerLinks.map((item, index) => {
                    const content = [];
                    content.push(item.destinationUri ? <a style={linkStyle} target={item.target} href={item.destinationUri}>{item.text}</a> : <span>{item.text}</span>);
                    if (index < footerLinks.length - 1) {
                      content.push(<span>|</span>);
                    }

                    return content;
                  })}
                </div>
              }
              <div className="Footer-rightsText">
                All Rights Reserved. For more information on this site, please read our {privacyPolicy}, {termsOfService}, and {adChoices}.
              </div>
            <a className="Footer-franklyLink" href="https://www.franklyinc.com" target="_blank">
                <PoweredByFranklyIcon />
              </a>
                                 </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

/**
 * Class representing the 'Powered by Frankly' SVG icon
 */
class PoweredByFranklyIcon extends Component {
  render() {
    return (
      <div className="PoweredByFranklyIcon">
              <Image src="https://frankly.images.worldnow.com/images/branding/powered-by-frankly-media.svg" width="150" alt="Powered by Frankly Media" imageClassNames="frankly-footer"/>
       </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./app/components/core/Footer.js